/* eslint-disable */
import React, { useState } from "react";
import "contents/assets/scss/page/promotion.scss";
import Paging from "../../component/Inc/Paging";
import PopPRBookletStock from "./_PopPRBookletStock";

const PRBookletStock = () => {
  const [modalPRBookletStock, setModalPRBookletStock] = useState(false);
  return (
    <main className="com_container p_pr_booklet_stock">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu7_7">홍보책자 재고관리</h2>
          <button
            onClick={() => {
              setModalPRBookletStock(true);
            }}
            className="com_btn orange s btn_plus"
          >
            홍보책자 목록 관리
          </button>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <select className="select">
                <option value="연도 선택">연도 선택</option>
              </select>
              <div className="com_btn_wrap">
                <button className="com_btn s btn_request red">
                  재고 부족(45)
                </button>
              </div>
              <section className="com_board_search end">
                <article className="search">
                  <input
                    type="search"
                    placeholder="검색할 내용을 입력"
                    className="input s type_search"
                  />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list main">
              <colgroup>
                <col width="10%" />
                <col width="10%" />
                <col width="20%" />
                <col width="40%" />
                <col width="10%" />
                <col width="10%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>영역</th>
                  <th>비고</th>
                  <th>홍보 책자 명</th>
                  <th>최근</th>
                  <th>재고</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>17</td>
                  <td>과탐</td>
                  <td>
                    <button className="btn_link">인쇄 책자</button>
                  </td>
                  <td>수학02 단단히 추려낸 단어집</td>
                  <td className="td_red">-05</td>
                  <td className="td_point">456</td>
                </tr>
                <tr>
                  <td>16</td>
                  <td>과탐</td>
                  <td>
                    <button className="btn_link">디지털 책자</button>
                  </td>
                  <td>수학02 단단히 추려낸 단어집</td>
                  <td className="td_red">-05</td>
                  <td className="td_point">456</td>
                </tr>
                <tr className="selected">
                  <td>15</td>
                  <td>과탐</td>
                  <td>
                    <button className="btn_link">인쇄 책자</button>
                  </td>
                  <td>수학02 단단히 추려낸 단어집</td>
                  <td className="td_red">-05</td>
                  <td className="td_point">456</td>
                </tr>
                <tr>
                  <td>14</td>
                  <td>과탐</td>
                  <td>
                    <button className="btn_link">인쇄 책자</button>
                  </td>
                  <td>수학02 단단히 추려낸 단어집</td>
                  <td className="td_red">-05</td>
                  <td className="td_point">456</td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{13 - idx}</td>
                      <td>과탐</td>
                      <td>
                        <button className="btn_link">인쇄 책자</button>
                      </td>
                      <td>수학02 단단히 추려낸 단어집</td>
                      <td className="td_red">-05</td>
                      <td className="td_point">456</td>
                    </tr>
                  );
                })}
                <tr>
                  <td>7</td>
                  <td>과탐</td>
                  <td>
                    <button className="btn_link">인쇄 책자</button>
                  </td>
                  <td>수학02 단단히 추려낸 단어집</td>
                  <td className="td_red">-05</td>
                  <td className="td_point">456</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>과탐</td>
                  <td>
                    <button className="btn_link">인쇄 책자</button>
                  </td>
                  <td>수학02 단단히 추려낸 단어집</td>
                  <td className="td_red">-05</td>
                  <td className="td_point">456</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>과탐</td>
                  <td>
                    <button className="btn_link">인쇄 책자</button>
                  </td>
                  <td>수학02 단단히 추려낸 단어집</td>
                  <td className="td_red">-05</td>
                  <td className="td_point">456</td>
                </tr>
              </tbody>
            </table>
            <Paging />
          </section>
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <hr className="com_divider" />
            <div className="booklet_box">
              <div className="booklet_btn_wrap">
                <span className="com_icon gray">인쇄 책자</span>
                <span className="com_icon gray">국어</span>
                <span className="com_icon gray">중3국어</span>
              </div>

              <button className="com_btn orange s btn_edit_pen">
                내용 수정
              </button>
            </div>
            <div className="booklet_title">2023 이지수능교육 핵심 홍보책자</div>
            <div className="file_box">
              <div className="com_input_upload flex_row">
                <p className="file">
                  <span className="txt">File name.pdf</span>
                  <button
                    type="button"
                    className="btn_del_file"
                    onClick={() => {}}
                  ></button>
                </p>
                <button
                  type="button"
                  className="btn_down"
                  onClick={() => {}}
                ></button>
              </div>
              <div className="com_input_upload flex_row">
                <p className="file">
                  <span className="txt">File name.pdf</span>
                  <button
                    type="button"
                    className="btn_del_file"
                    onClick={() => {}}
                  ></button>
                </p>
                <button
                  type="button"
                  className="btn_down"
                  onClick={() => {}}
                ></button>
              </div>
            </div>
            <div className="com_board_list__scroll">
              <table className="com_board_list">
                <colgroup>
                  <col width="10%" />
                  <col width="40%" />
                  <col width="15%" />
                  <col width="15%" />
                  <col width="15%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>요청일</th>
                    <th>입출고 자</th>
                    <th>입출 권 수</th>
                    <th>재고</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>17</td>
                    <td className="td_date">2022,08,25 18 : 30</td>
                    <td>가길동201</td>
                    <td className="td_red">-45</td>
                    <td className="td_red">456</td>
                  </tr>
                  <tr>
                    <td>16</td>
                    <td className="td_date">2022,08,25 18 : 30</td>
                    <td>가길동201</td>
                    <td className="td_red">-45</td>
                    <td className="td_point">456</td>
                  </tr>
                  <tr>
                    <td>15</td>
                    <td className="td_date">2022,08,25 18 : 30</td>
                    <td>가길동201</td>
                    <td className="td_red">-45</td>
                    <td className="td_point">456</td>
                  </tr>
                  <tr>
                    <td>14</td>
                    <td className="td_date">2022,08,25 18 : 30</td>
                    <td>가길동201</td>
                    <td className="td_point">+21</td>
                    <td className="td_point">456</td>
                  </tr>
                  <tr>
                    <td>13</td>
                    <td className="td_date">2022,08,25 18 : 30</td>
                    <td>가길동201</td>
                    <td className="td_point">+21</td>
                    <td className="td_point">456</td>
                  </tr>
                  <tr>
                    <td>12</td>
                    <td className="td_date">2022,08,25 18 : 30</td>
                    <td>가길동201</td>
                    <td className="td_point">+21</td>
                    <td className="td_point">456</td>
                  </tr>
                  <tr>
                    <td>11</td>
                    <td className="td_date">2022,08,25 18 : 30</td>
                    <td>가길동201</td>
                    <td className="td_point">+21</td>
                    <td className="td_point">456</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td className="td_date">2022,08,25 18 : 30</td>
                    <td>가길동201</td>
                    <td className="td_point">+21</td>
                    <td className="td_point">456</td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td className="td_date">2022,08,25 18 : 30</td>
                    <td>가길동201</td>
                    <td className="td_point">+21</td>
                    <td className="td_point">456</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td className="td_date">2022,08,25 18 : 30</td>
                    <td>가길동201</td>
                    <td className="td_point">+21</td>
                    <td className="td_point">456</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td className="td_date">2022,08,25 18 : 30</td>
                    <td>가길동201</td>
                    <td className="td_point">+21</td>
                    <td className="td_point">456</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td className="td_date">2022,08,25 18 : 30</td>
                    <td>가길동201</td>
                    <td className="td_point">+21</td>
                    <td className="td_point">456</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="com_info line">
              <p className="name">홍길동103</p>
              <p className="date dot">2023, 05, 20 11 : 30</p>
            </div>
            <div className="com_input_wrap flex_row">
              <div className="check">
                <input
                  type="radio"
                  name="rdo"
                  id="rdo01"
                  className="com_chk circle"
                />
                <label htmlFor="rdo01">입고</label>
                <input
                  type="radio"
                  name="rdo"
                  id="rdo02"
                  className="com_chk circle"
                />
                <label htmlFor="rdo02">출고</label>
              </div>
              <div className="input_box">
                <span className="input_txt">권 수 입력</span>
                <input type="text" className="input" defaultValue={`4567000`} />
              </div>
            </div>

            <hr className="com_divider" />
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange xs">등록</button>
            </div>
          </section>
        </section>
      </div>
      <PopPRBookletStock
        open={modalPRBookletStock}
        close={() => setModalPRBookletStock(false)}
      />
    </main>
  );
};

export default PRBookletStock;
